import { createGlobalState } from 'react-use';

import { VisitSettlementStatus } from '@dreryk/egabinet-financial-settlement-frontend-api';

type VisitSettlementStatusGetter = (appointmentId: number) => VisitSettlementStatus | null;
type VisitSettlementStatusUpdater = (state: Map<number, VisitSettlementStatus>) => void;
type VisitSettlementStatusReset = VoidFunction;

type WithoutVisitSettlementStatus = Map<number, never>;

type WithVisitSettlementStatus = Map<number, VisitSettlementStatus>;

export type VisitSettlementStatusGlobalState = WithoutVisitSettlementStatus | WithVisitSettlementStatus;

const useGlobalState = createGlobalState<VisitSettlementStatusGlobalState>(new Map());

type UseVisitSettlementStatusGlobalStateReturnFn = {
   getStatus: VisitSettlementStatusGetter;
   updateStatus: VisitSettlementStatusUpdater;
   resetStatus: VisitSettlementStatusReset;
};

export const useVisitSettlementStatusGlobalState = (): UseVisitSettlementStatusGlobalStateReturnFn => {
   const [globalState, setGlobalState] = useGlobalState();

   const getStatus: VisitSettlementStatusGetter = (appointmentId) => {
      return globalState.get(appointmentId) ?? null;
   };

   const resetStatus: VisitSettlementStatusReset = () => {
      setGlobalState(new Map());
   };

   return {
      getStatus: getStatus,
      updateStatus: setGlobalState,
      resetStatus: resetStatus,
   };
};
